var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0897 3.875H4.37179C1.95732 3.875 0 5.83232 0 8.24679V20.9647C0 23.3792 1.95732 25.3365 4.37179 25.3365H17.0897C19.5042 25.3365 21.4615 23.3792 21.4615 20.9647V19.7143L26.9742 22.47C27.8365 22.9009 28.8603 22.8548 29.6802 22.3482C30.5002 21.8416 30.9995 20.9467 31 19.9829V9.22926C30.9995 8.26481 30.5002 7.36992 29.6802 6.86334C28.8603 6.35675 27.8365 6.31064 26.9744 6.74147L21.4615 9.49728V8.24679C21.4615 5.83232 19.5042 3.875 17.0897 3.875ZM21.4615 12.1631V17.0476L28.0403 20.337C28.1388 20.3862 28.2521 20.3918 28.3535 20.3551L28.4268 20.3195C28.544 20.2472 28.6153 20.1193 28.6154 19.9823V9.22989C28.6153 9.09221 28.544 8.96436 28.4268 8.89199C28.3097 8.81963 28.1635 8.81304 28.0405 8.87451L21.4615 12.1631ZM19.0769 11.4263V8.2468C19.0769 7.14931 18.1872 6.25962 17.0897 6.25962H4.3718C3.27431 6.25962 2.38462 7.14931 2.38462 8.2468V20.9647C2.38462 22.0622 3.27431 22.9519 4.3718 22.9519H17.0897C18.1872 22.9519 19.0769 22.0622 19.0769 20.9647V17.7853V11.4263Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.d2a90ad58d52e6469b6fb5390edb0c2e.svg";
export { ForwardRef as ReactComponent };